import React, { useEffect, useMemo, useState } from "react";
import NoRecords from "../../components/alerts/NoRecords";
import { Breadcrumb } from "../../components/ui/Breadcrumb";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import OrganizationRepository from "../../repositories/OrganizationRepository";

const NotFoundPage = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [show, setShow] = useState(false);

    useEffect(() => {
        if (!location.state?.show) {
            navigate("/", { replace: true });
            return;
        }

        setShow(true);
    }, [location, navigate]);

    const { organizationPreference } = useSelector(
        (state) => state.preferenceSlice
    );

    const { organizations: allOrganizations, parentOrganizations } =
        useSelector((state) => state.userDetails);

    // Route navigation always uses the numeric ORGANIZATIONID (IDHP) / orgId GUID (ODS, same value as ORGANIZATIONID),
    // never the ISF id that organizationPreference is stored in.
    const employeeUrl = useMemo(() => {
        if (organizationPreference.length === 0) {
            return parentOrganizations.length === 1
                ? `/organization/${parentOrganizations[0].ORGANIZATIONID}/employees/search`
                : "";
        }

        const preferredOrganization =
            OrganizationRepository.getOrganizationByStandardId(
                allOrganizations,
                organizationPreference[0]
            );

        return preferredOrganization
            ? `/organization/${preferredOrganization.ORGANIZATIONID}/employees/search`
            : "";
    }, [organizationPreference, parentOrganizations, allOrganizations]);

    return (
        <div
            style={{
                marginTop: "1.875rem",
            }}
        >
            {show && (
                <>
                    {/* TODO: Make this generic */}
                    <Breadcrumb
                        links={[
                            {
                                path: "/search",
                                name: "Search",
                            },
                            {
                                path: employeeUrl,
                                name: "Employee",
                            },
                            {
                                name: "Claim & Leave",
                            },
                        ]}
                    />

                    <NoRecords
                        page="claim & leave"
                        label="claim & leave"
                        attribute1="claim & leave"
                        attribute3="claim_error"
                    />
                </>
            )}
        </div>
    );
};

export default NotFoundPage;
